module.exports = __webpack_public_path__ + "static/media/waiting-for-host.3615a328.svg";